export default __webpack_public_path__ + "static/media/pic9.782236e3.jpg";